import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "../../../../../../components/Inputs/Select";

export const useSalaryOrHourlyFilter = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      name: "salaryOrHourly",
      label: t("salary-or-hourly"),
      type: "select",
      component: (
        <Select>
          <Select.Option value="S">{ t('salaried')}</Select.Option>
          <Select.Option value="H">{ t('hourly')}</Select.Option>
         </Select>
      ),
    }),
    [t]
  );
};
